import { Injectable } from '@angular/core';
import { Token } from 'src/app/manager/token';
// import { Http, Headers, ResponseContentType } from '@angular/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import jwt_decode from "jwt-decode";
import { HttpClient } from '@angular/common/http';
import { CommonService } from '../common-service';

interface JwtPayload {
      [x: string]: string;
  Employee_Code: string;
  Clients: any;
}
@Injectable({
    providedIn: 'root'
})

export class InventoryService {
    Token;
    TokenCls: Token = new Token(this.router);
    constructor(private http: HttpClient, private router: Router) { }

    ngOnInit(): void {
        // let tkclass = new Token();
        // this.Token = tkclass.GetToken();
        // headers.append('Access_Token', this.Token);
    }

    GetAllInventory(clientid):any {
        return this.http.get(environment.ApiUrl + '/api/client-inventory/client/' + clientid);
    }
    InventoryUpload(file: any): any {
        return this.http.post(environment.FileApiUrl + '/api/client-inventory-upload', file);
    }

    InsertOrUpdateInventory(InventoryData): any {
        return this.http.post(environment.ApiUrl + '/api/client-inventory', InventoryData);
    }

    DownloadTemplate():any {
        return this.http.get(environment.ApiUrl + '/api/client-inventory-download-template', { responseType: 'blob'})
            .pipe(map(res => {
                return {
                    filename: 'Inventory_Template.xlsx',
                    data: res
                };
            }));
    }

    getInventoryDropdownList():any {
        // Get_Agent_High_Priority_Field_List
        return this.http.get(environment.ApiUrl + `/api/Get_Agent_High_Priority_Field_List`).pipe(map(res => res));
    }

    searchInventory(fieldName, reference,old_Inventory_Log_Id):any {
        //let userData = jwt_decode(this.TokenCls.GetToken());
        //let userData =  jwt_decode(CommonService.decryptData(this.TokenCls.GetToken()));
            const userData = jwt_decode<JwtPayload>(CommonService.decryptData(this.TokenCls.GetToken()));
        userData.Clients = JSON.parse(sessionStorage.getItem('access_client_data'))
        console.log('searchInventory userData : ', userData);
        return this.http.get(environment.ApiUrl + `/api/Get_SQ_Bucket_High_Priority_List/?client_Id=${userData.Clients[0].Client_Id}&display_Name=${fieldName}&text_Value=${reference}&bucket_name=Special_Queue`).pipe(map(res => res));
    }

    searchCallReferenceAccounts(reference,Old_Inventory_Log_Id):any {
        //let userData = jwt_decode(this.TokenCls.GetToken());
         const userData = jwt_decode<JwtPayload>(CommonService.decryptData(this.TokenCls.GetToken()));
        userData.Clients = JSON.parse(sessionStorage.getItem('access_client_data'))
        console.log('searchCallReferenceAccounts userData : ', userData);
        //return this.http.get(environment.ApiUrl + `api/Get_Inventory_By_CallReferenceNo/${userData.Clients[0].Client_Id}/${reference}/${Old_Inventory_Log_Id}').pipe(map(res => res));
        return this.http.get(environment.ApiUrl + `/api/Get_Inventory_By_CallReferenceNo/${userData.Clients[0].Client_Id}/${reference}/${Old_Inventory_Log_Id}`).pipe(map(res => res));

    }

    gethighPriorityFields(inventoryid, inventoryLogId, old_Inventory_Log_Id ,bucket_name):any {
        // http://172.30.52.25:1001/api/Get_SQ_Inventory_Details_For_Agent/6033/28/0?bucket_Name=Special_Queue
        //let userData = jwt_decode(this.TokenCls.GetToken());
        //let userData =  jwt_decode(CommonService.decryptData(this.TokenCls.GetToken()));
          const userData = jwt_decode<JwtPayload>(CommonService.decryptData(this.TokenCls.GetToken()));
        userData.Clients = JSON.parse(sessionStorage.getItem('access_client_data'))
        console.log('searchCallReferenceAccounts userData : ', userData);
        return this.http.get(environment.ApiUrl + `/api/Get_SQ_Inventory_Details_For_Agent/${userData.Clients[0].Client_Id}/${inventoryid}/${inventoryLogId}/${old_Inventory_Log_Id}/?bucket_Name=${bucket_name}`).pipe(map(res => res));
    }

    // Get isMandate
    getIsMultigrid(clientId):any {
      // Get_Agent_High_Priority_Field_List
      //let userData = jwt_decode(this.TokenCls.GetToken());
      let userData =  jwt_decode(CommonService.decryptData(this.TokenCls.GetToken()));
      return this.http.get(environment.ApiUrl + `/api/Client-Multigrid/client/${clientId}`).pipe(map(res => res));
  }

    GetAllCBFList(clientid):any{
    return this.http.get(environment.ApiUrl + '/api/client-inventory/CBFList/' + clientid);
}
}
